import axios from "../../../axios"
import { getCurrentTenant } from '@/utils'
import store from "@/store/store";
import { CustomerChatService } from "@/db/customerChat_service";
import Vue from "@/main";

export default {
    async fetch(instanceId, customerId) {
        await store.dispatch('setShowLoadingOverlay', false);
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        const ccService = new CustomerChatService();
        let last = await ccService.getLastMessage(customerId, instanceId);
        return await new Promise(async () => {
            return await axios.post('', {
                query: `
                        query {
                          customerChats (
                            id: ${last}
                            customer_id: ${customerId},
                            instance_id: ${instanceId},
                            all_users: true,
                          ) {
                            ack,
                            customer_id,
                            document_mimetype,
                            caption,
                            document_name,
                            chat_ticket_id,
                            hash,
                            id,
                            is_bot_message,
                            message,
                            message_footer,
                            message_header,
                            message_buttons,
                            sent_at,
                            tag_type,
                            type,
                            off_customer_chat,
                            whatsapp_deleted_at,
                            recovered,
                            instance_id,
                            is_edited,
                            user_sending_id,
                            user_sending_img,
                            is_log_message,
                            parentCustomerChat {
                                ack,
                                customer_id,
                                document_mimetype,
                                caption,
                                document_name,
                                chat_ticket_id,
                                hash,
                                id,
                                is_edited,
                                is_bot_message,
                                message,
                                message_footer,
                                message_header,
                                message_buttons,
                                sent_at,
                                tag_type,
                                type,
                                off_customer_chat,
                                whatsapp_deleted_at,
                                recovered,
                                user_sending_id,
                                user_sending_img,
                                instance_id,
                            },
                            customerChatStatus {
                                 id,
                                 url,
                                 caption,
                                 mimetype,
                            },
                            customerChatReactions{
                                 id,
                                 ack,
                                 type,
                                 sent_at,
                                 customer_id,
                                 reaction_text,
                                 customer_chat_id,
                            },
                          }
                        }
                      `
            }).then(async chats => {
                if (chats.data) {
                    return await ccService.insert(chats.data.data.customerChats, false, false, true);
                }
            })
        })
    },
    async loadPaginated(chatTickets, page, limit, crontab = false, update = false) {
        await store.dispatch('setShowLoadingOverlay', false);
        let promises = [];
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        const ccService = new CustomerChatService();
        for (const chatTicket of chatTickets) {
            promises.push(
                axios.post('', {
                        query: this.queryToLoad(
                            chatTicket.instance_id !== null ? chatTicket.instance_id : null,
                            chatTicket.customer_id !== null ? chatTicket.customer_id : null,
                            page,
                            limit,
                            chatTicket.hash !== undefined ? chatTicket.hash : null,
                            update ? await ccService.getLastMessage(chatTicket.customer_id, chatTicket.instance_id) : 0
                        )
                    }
                )
            )
        }

        return await this.executeFetch(promises, crontab)
        
    },
    async executeFetch(promises, crontab) {
        let count = 0;
        
        return Promise.all(promises)
            .then(async (datas) => {
                count = 0;
                if (datas.length >= 1) {
                    for(const data of datas) {
                        await this.insertData(data.data.data.customerChatsPaginated, crontab)
                        count += data.data.data.customerChatsPaginated.data.length
                    }
                }
                return count;
            })
            .catch((error) => {
                console.log(error)
                return 0;
            })
    },
    async insertData(customerChatsPaginated, crontab) {
        const ccService = new CustomerChatService();
        if (crontab) {
            if (customerChatsPaginated.data[0] !== undefined) {
                await ccService.removeInsert(customerChatsPaginated.data[0]);
                Vue.$events.fire('DeleteJobReceivedMessage', customerChatsPaginated.data[0].hash);
            }
            return;
        } 
        await ccService.insert(customerChatsPaginated.data, false, false, false, false);
    },
    queryToLoad(instanceId, customerId, page, limit, hash = null, lastMsg) {
        return `
                query {
                      customerChatsPaginated (
                          `+ (customerId != null ? `customer_id: ${customerId},` : '') + `,
                          `+ (instanceId != null ? `instance_id: ${instanceId},` : '') + `,
                          `+ (hash != null ? `hash: "${hash}",` : '') + `,
                          pagination_page: ${page},
                          pagination_limit: ${limit},
                          id: ${lastMsg}
                      ) {
                          data {
                                ack,
                                customer_id,
                                document_mimetype,
                                caption,
                                document_name,
                                chat_ticket_id,
                                hash,
                                id,
                                is_bot_message,
                                message,
                                message_footer,
                                message_header,
                                message_buttons,
                                sent_at,
                                tag_type,
                                type,
                                is_edited,
                                off_customer_chat,
                                whatsapp_deleted_at,
                                recovered,
                                instance_id,
                                user_sending_id,
                                user_sending_img,
                                is_log_message,
                                parentCustomerChat {
                                    ack,
                                    customer_id,
                                    document_mimetype,
                                    caption,
                                    document_name,
                                    chat_ticket_id,
                                    hash,
                                    id,
                                    is_bot_message,
                                    message,
                                    message_footer,
                                    message_header,
                                    message_buttons,
                                    sent_at,
                                    is_edited,
                                    tag_type,
                                    type,
                                    off_customer_chat,
                                    whatsapp_deleted_at,
                                    recovered,
                                    user_sending_id,
                                    user_sending_img,
                                    instance_id
                                },
                                customerChatStatus {
                                     id,
                                     url,
                                     caption,
                                     mimetype,
                                },
                                customerChatReactions{
                                     id,
                                     ack,
                                     type,
                                     sent_at,
                                     customer_id,
                                     reaction_text,
                                     customer_chat_id,
                                },
                          },
                          total,
                          per_page
                      }
                }
              `
    }
}